<template>
  <div class="sub-form-boolean sub-columns">
    <BaseInput class="sub-col" v-model="form.onVal" label="True value" hint="Value of true" validate="required" name="on value"/>
    <BaseInput class="sub-col" v-model="form.offVal" label="False value" hint="Value of false" validate="required" name="off value"/>
  </div>
</template>

<script>
  import subformMixin from '@/mixins/sub-form.mixin'

  export default {
    mixins: [ subformMixin ],
    data () {
      return {
        form: {
          onVal: 'On',
          offVal: 'Off'
        }
      }
    }
  }
</script>

<style lang="scss">

  .sub-form-boolean {
  }
</style>


// WEBPACK FOOTER //
// src/components/forms/sub-forms/SubFormBoolean.vue